var $6f40c3a58f594b58$exports = {};
const $6f40c3a58f594b58$var$timerRef = document.querySelector('.timer');
let $6f40c3a58f594b58$var$count = 60;
const $6f40c3a58f594b58$var$id = setInterval(()=>{
    if ($6f40c3a58f594b58$var$count <= 1) clearInterval($6f40c3a58f594b58$var$id);
    if ($6f40c3a58f594b58$var$count === 30) alert("\u041F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u0447\u0430\u0441\u0443");
    $6f40c3a58f594b58$var$count--;
    let m = Math.floor($6f40c3a58f594b58$var$count / 60);
    let s = Math.floor($6f40c3a58f594b58$var$count % 60);
    $6f40c3a58f594b58$var$timerRef.textContent = `\u{445}\u{432}\u{438}\u{43B}\u{438}\u{43D}\u{438}: ${m < 10 ? '0' + m : m} \u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{438}: ${s < 10 ? '0' + s : s}`;
}, 1000);
const $6f40c3a58f594b58$var$boxRef = document.querySelector('.box');
const $6f40c3a58f594b58$var$secondRef = document.querySelector('.second');
const $6f40c3a58f594b58$var$btnRef = document.querySelector('.btn');
let $6f40c3a58f594b58$var$num = 30000;
$6f40c3a58f594b58$var$btnRef.addEventListener('click', ()=>{
    $6f40c3a58f594b58$var$btnRef.style.backgroundColor = 'red';
    const idMs = setInterval(()=>{
        if (Math.floor($6f40c3a58f594b58$var$num / 1000) <= 0 && Math.floor($6f40c3a58f594b58$var$num % 1000 / 10) <= 1) {
            clearInterval(idMs);
            $6f40c3a58f594b58$var$btnRef.style.backgroundColor = 'green';
        }
        if (Math.floor($6f40c3a58f594b58$var$num / 1000) === 10) $6f40c3a58f594b58$var$boxRef.style.backgroundColor = 'green';
        $6f40c3a58f594b58$var$num -= 10;
        let s = Math.floor($6f40c3a58f594b58$var$num / 1000);
        let ms = Math.floor($6f40c3a58f594b58$var$num % 1000 / 10);
        $6f40c3a58f594b58$var$secondRef.textContent = `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}: ${s} \u{43C}\u{456}\u{43B}\u{456}\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}: ${ms} `;
    }, 10);
});


//# sourceMappingURL=homework-second.7552f123.js.map
